module.exports = __webpack_public_path__ + "static/img/img-home-service-02.89c3993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-service-02.png
// module id = 1f4B
// module chunks = 1